import address from 'plugins/i18n/entity/address.de.ts'
import role from 'plugins/i18n/entity/role.de.ts'

const person = {
	name: 'Person | Personen',
	icon: 'fas fa-user | fas fa-users',
	fields: {
		hp_id: 'ID',
		lastname: 'Name',
		address: {
			...address.fields,
		},
		role: {
			...role.fields,
		},
		user_id: 'Konto',
		user: {
			tos: ' ',
			email: 'E-Mail',
		},
		person: {
			lastname: '@:entity.person.fields.lastname',
			user_id: 'Konto',
		},
		unit: {
			position: '@:entity.unit.fields.position',
		},
		started_at: '@:entity.role.fields.started_at',
		ended_at: '@:entity.role.fields.ended_at',
	},
}

export default person
